/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Bytes, BytesInterface } from "../Bytes";

const _abi = [
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_hash",
        type: "bytes32",
      },
    ],
    name: "hash2base32",
    outputs: [
      {
        internalType: "string",
        name: "_uintAsString",
        type: "string",
      },
    ],
    stateMutability: "pure",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "num",
        type: "uint256",
      },
    ],
    name: "uint2str",
    outputs: [
      {
        internalType: "string",
        name: "_uintAsString",
        type: "string",
      },
    ],
    stateMutability: "pure",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "i",
        type: "uint256",
      },
    ],
    name: "uint2hexstr",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "pure",
    type: "function",
    constant: true,
  },
];

const _bytecode =
  "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";

type BytesConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: BytesConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Bytes__factory extends ContractFactory {
  constructor(...args: BytesConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "Bytes";
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Bytes> {
    return super.deploy(overrides || {}) as Promise<Bytes>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): Bytes {
    return super.attach(address) as Bytes;
  }
  connect(signer: Signer): Bytes__factory {
    return super.connect(signer) as Bytes__factory;
  }
  static readonly contractName: "Bytes";
  public readonly contractName: "Bytes";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): BytesInterface {
    return new utils.Interface(_abi) as BytesInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Bytes {
    return new Contract(address, _abi, signerOrProvider) as Bytes;
  }
}
